import { createRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { rootRoute } from './__root';
import { useQuizStore } from '@/stores/quiz-store';
import { QuizRenderer } from '@/features/quiz';
import { settlementQuiz } from '@/features/quiz/config/settlement-quiz';
import { useNavigateWithParams } from '@/shared/hooks/use-navigate-with-params';

interface QuizSearch {
  variant: string;
}

export const quizRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/quiz',
  validateSearch: (raw: Record<string, unknown>): QuizSearch => ({
    variant: typeof raw.variant === 'string' ? raw.variant : 'default',
  }),
  component: QuizPage,
});

function QuizPage() {
  const navigate = useNavigateWithParams();
  const { variant } = quizRoute.useSearch();
  const setVariant = useQuizStore((s) => s.setVariant);
  const completed = useQuizStore((s) => s.completed);
  const answers = useQuizStore((s) => s.answers);
  const reset = useQuizStore((s) => s.reset);

  useEffect(() => {
    setVariant(variant);
  }, [variant, setVariant]);

  // Drop leftover answers from the previous demo quiz (or other configs).
  useEffect(() => {
    const stepIds = new Set(settlementQuiz.steps.map((step) => step.id));
    const answerIds = Object.keys(answers);
    if (answerIds.some((id) => !stepIds.has(id))) {
      reset();
    }
  }, [answers, reset]);

  useEffect(() => {
    if (completed) {
      navigate({ to: '/checkout' });
    }
  }, [completed, navigate]);

  const handleComplete = () => {
    navigate({ to: '/checkout' });
  };

  return (
    <div className="min-h-[100dvh] bg-mf-neutral-50">
      <div className="mx-auto w-full max-w-[500px]">
        <QuizRenderer config={settlementQuiz} onComplete={handleComplete} />
      </div>
    </div>
  );
}
